module.exports = __webpack_public_path__ + "media/images/buildings-and-contents-graphic-72e6d22a.png";